99<template>

    <v-row class="d-flex justify-space-between align-center mb-2 mt-2">
      <v-col cols="auto" class="d-flex align-center">
        <v-tooltip v-if="props.isClubManager" location="top" :text="$t('club.club_members.add_member')">
          <template v-slot:activator="{ props: tipProps }">
            <v-btn
              v-bind="tipProps"
              icon
              variant="text"
              color="success"
              @click="showRegistration = true"
            >
              <v-icon size="45">mdi-account-multiple-plus</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </v-col>

      <v-col cols="auto" class="d-flex align-center ga-1 ml-auto" v-if="props.isClubManager">
        <v-tooltip location="top" :text="$t('club.club_members.copy_emails_tooltip')">
          <template v-slot:activator="{ props: tipProps }">
            <v-btn
              v-bind="tipProps"
              icon
              variant="text"
              color="primary"
              @click="copyEmails"
            >
              <v-icon size="x-large">mdi-email-multiple-outline</v-icon>
            </v-btn>
          </template>
        </v-tooltip>

        <v-menu v-if="(props.club?.club_country || '').toUpperCase() === 'CZE'" location="bottom">
          <template v-slot:activator="{ props: menuProps }">
            <v-btn
              v-bind="menuProps"
              icon
              variant="text"
              color="primary"
              :loading="loadingNsaExport"
            >
              <v-icon size="x-large">mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item
              :title="$t('club.club_members.nsa_export_muj_klub')"
              @click="downloadNsaExport('muj_klub')"
            />
            <v-list-item
              :title="$t('club.club_members.nsa_export_rejstrik')"
              @click="downloadNsaExport('rejstrik')"
            />
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <!-- Dialog registrace člena -->
    <v-dialog v-model="showRegistration" max-width="900px">
      <v-card>
        <ClubPageRegistration
          :club="props.club"
          @registered="onRegistered"
          @close="showRegistration = false"
        />
      </v-card> 
    </v-dialog>


    <v-data-table
    :headers="memberHeaders"
    density="compact"
    :items="filteredMembers"
    item-key="id"
    :loading="loading"
    loading-text="general.loading"
    :items-per-page="-1"
    :sort-by="sortBy"
    width="100%"
    striped="even"
    hover
    >
    <!-- Textové filtry ve sloupcích; zachová výchozí Vuetify šipky řazení -->
    <template
      v-for="key in TEXT_FILTER_COLUMNS"
      :key="key"
      v-slot:[`header.${key}`]="{ column, getSortIcon }"
    >
      <div class="member-header-cell">
        <div class="v-data-table-header__content">
          <span>{{ column.title }}</span>
          <v-icon
            v-if="column.sortable"
            class="v-data-table-header__sort-icon"
            :icon="getSortIcon(column)"
          />
        </div>
        <v-text-field
          v-model="columnFilters[key]"
          class="member-header-filter"
          density="compact"
          variant="outlined"
          hide-details
          :placeholder="$t('club.club_members.filter_placeholder')"
          @click.stop
          @mousedown.stop
        />
      </div>
    </template>

    <template v-slot:[`header.current_vt`]="{ column, getSortIcon }">
      <div class="member-header-cell member-header-cell--center">
        <div class="v-data-table-header__content">
          <span>{{ column.title }}</span>
          <v-icon
            v-if="column.sortable"
            class="v-data-table-header__sort-icon"
            :icon="getSortIcon(column)"
          />
        </div>
        <v-select
          v-model="vtFilter"
          class="member-header-filter"
          :items="VT_SELECT_ITEMS"
          density="compact"
          variant="outlined"
          hide-details
          multiple
          :placeholder="$t('club.club_members.filter_placeholder')"
          @click.stop
          @mousedown.stop
        />
      </div>
    </template>

    <template v-slot:[`header.organizer`]="{ column }">
      <div class="member-header-cell">
        <div class="v-data-table-header__content">
          <span>{{ column.title }}</span>
        </div>
        <div class="member-bool-filter" @click.stop @mousedown.stop>
          <v-checkbox
            v-model="boolFilters.organizer"
            density="compact"
            hide-details
          />
        </div>
      </div>
    </template>

    <template v-slot:[`header.club_manager`]="{ column }">
      <div class="member-header-cell">
        <div class="v-data-table-header__content">
          <span>{{ column.title }}</span>
        </div>
        <div class="member-bool-filter" @click.stop @mousedown.stop>
          <v-checkbox
            v-model="boolFilters.club_manager"
            density="compact"
            hide-details
          />
        </div>
      </div>
    </template>

    <template v-slot:[`header.actions`]="{ column }">
      <div class="member-header-cell">
        <div class="v-data-table-header__content">
          <span>{{ column.title }}</span>
        </div>
      </div>
    </template>
    <!-- <template v-slot:loading>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </template> -->
    <template v-slot:[`item.last_name`]="{ item }">
    <v-tooltip location="top center" origin="auto" :text="t('general.last_activity') + ': ' + $formatDateTime(item.last_activity)">
        <template v-slot:activator="{ props }">
        <router-link v-bind="props" :to="'/ucet/' + item.id" style="white-space: nowrap;">{{ item.last_name }} {{ item.first_name }}</router-link>
        </template>
    </v-tooltip> 
    </template>
    <!-- <template v-slot:[`item.gender`]="{ item }">
    {{ item.gender === 'M' ? 'Muž' : 'Žena' }}
    </template> -->
    <template v-slot:[`item.current_vt`]="{ item }">
      <div class="text-center">{{ item.current_vt }}</div>
    </template>

    <template v-if="isClubManager" v-slot:[`item.email`]="{ item }">
    {{ item.email }}
    </template>
    <template v-if="isClubManager" v-slot:[`item.si_number`]="{ item }">
    {{ item.si_number }}
    </template>
    <template v-if="isClubManager" v-slot:[`item.organizer`]="{ item }">
    <v-checkbox
      :model-value="item.is_organizer"
      hide-details
      :disabled="!isChairman || savingPermissionRoleId === item.role_id"
      density="compact"
      @update:model-value="(val) => savePermission(item, 'is_organizer', val)"
    ></v-checkbox>
    </template>
    <template v-if="isClubManager" v-slot:[`item.club_manager`]="{ item }">
    <v-checkbox
        :model-value="item.is_club_manager"
        :disabled="item.id === Number(authStore.userID) || !isChairman || savingPermissionRoleId === item.role_id"
        hide-details
        density="compact"
        @update:model-value="(val) => savePermission(item, 'is_club_manager', val)"
    ></v-checkbox>
    </template>
    <template v-if="isClubManager" v-slot:[`item.actions`]="{ item }">
    <v-list-item-action>
        <v-icon @click="openEditDialog(item)" color="blue" size="x-large" class="mr-2" title="editovat údaje člena">mdi-pencil</v-icon>
        <v-icon @click="openRemoveDialog(item)" v-if="item.id !== Number(authStore.userID) && isChairman" color="warning" size="x-large" class="mr-2" title="zrušit členství v oddíle">mdi-account-remove</v-icon>
        <v-icon v-if="canDeleteAccount(item) && item.id !== Number(authStore.userID) && isChairman" @click="openDeleteDialog(item)" color="red" size="x-large" title="smazat účet">mdi-delete</v-icon>
    </v-list-item-action>
    </template>
    <template v-slot:no-data>
    <v-alert type="info" class="ma-4">
       {{ $t('club.club_members.no_members') }}
    </v-alert>
    </template>
    </v-data-table>

    <!-- Dialog pro editaci Account -->
    <v-dialog v-model="dialogEditAccount" persistent max-width="1000px">
    <v-card>
        <v-card-title>
            {{ selectedAccount.last_name }} {{ selectedAccount.first_name }} ({{ selectedAccount.index }})
        </v-card-title>
        <v-card-text>

            <v-row>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.last_name" :label="$t('club.club_members.headers.last_name')" required :rules="[rules.last_name]"></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.first_name" :label="$t('club.club_members.headers.first_name')" required :rules="[rules.firstName]"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
                <CountrySelect v-model="selectedAccount.country" :label="$t('club.club_members.headers.country')" />
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.email" :label="$t('club.club_members.headers.email')" :rules="[rules.isValidEmail]" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field v-model="selectedAccount.si_number" type="number" :label="$t('club.club_members.headers.si_number')" :rules="[rules.siNumber]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-autocomplete
                v-model="selectedAccount.assist_user"
                :items="assistUser.filter(u => u.id !== selectedAccount.id)"
                :label="$t('club.club_members.headers.assist_user')"
                item-value="id"
                item-title="fullName"
                clearable
                multiple
                chips
                closable-chips
                no-data-text="settings.assist_user_no_data"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="selectedAccount.birth_year" :label="$t('club.club_members.headers.birth_year')" type="number" :rules="[rules.year]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-select v-model="selectedAccount.gender" :items="sexOptions" :label="$t('club.club_members.headers.gender')" :rules="[rules.gender]"></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="selectedAccount.index" :label="$t('club.club_members.headers.index')" required :rules="[rules.index]"></v-text-field>
            </v-col>
            </v-row>

            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogEditAccount = false">{{ $t('general.cancel') }}</v-btn>
            <v-btn color="green darken-1" text @click="editAccount" :disabled="!isFormValid">{{ $t('general.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>



    <!-- Dialog pro potvrzení smazání člena oddílu -->
    <v-dialog v-model="dialogRemoveAccount" persistent max-width="600px">
        <v-card>
            <v-card-title class="text-h5">{{ $t('club.club_members.remove_title') }}</v-card-title>
            <v-card-text>
               <i18n-t keypath="club.club_members.remove_text">
                <strong>{{ selectedAccount.first_name }} {{ selectedAccount.last_name }}</strong>
              </i18n-t>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogRemoveAccount = false">{{ $t('general.cancel') }}</v-btn>
            <v-btn color="warning darken-1" text @click="removeAccount">{{ $t('club.club_members.remove_btn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>



        <!-- Dialog pro potvrzení smazání Account -->
        <v-dialog v-model="dialogDeleteAccount" persistent max-width="600px">
        <v-card>
            <v-card-title class="text-h5">{{ $t('club.club_members.delete_title') }}</v-card-title>
            <v-card-text>
              <i18n-t keypath="club.club_members.delete_text">
                <strong>{{ selectedAccount?.first_name }} {{ selectedAccount?.last_name }} ({{ selectedAccount?.index }})</strong>
              </i18n-t>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogDeleteAccount = false">{{ $t('general.cancel') }}</v-btn>
            <v-btn color="red darken-1" text @click="deleteAccount">{{ $t('general.delete') }}</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

  <ScrollTopButton />

</template>


<script setup>
import { ref, computed, reactive } from 'vue';
import { useRoute } from 'vue-router';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';

import CountrySelect from '@/components/shared/CountrySelect.vue';
import ScrollTopButton from '@/components/shared/ScrollTopButton.vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import ClubPageRegistration from './ClubPageMembersTableRegistration.vue';
import { useI18n } from 'vue-i18n'

const snackbar = useSnackbarStore()
const authStore = useAuthStore();
const { t } = useI18n();

const props = defineProps({
    members: Array,
    club: Object,
    assistUser: Array,
    isClubManager: Boolean,
    isChairman: Boolean,    
    loading: Boolean,
  });


const emit = defineEmits(['fetchMembers']);

// const { isLoggedIn } = storeToRefs(useAuthStore());
const route = useRoute();
const clubShortcut = ref(route.params.id); // Získání ID oddílu z URL

const sortBy = [{ key: 'last_name', order: 'asc' }]; // Klíč pro řazení

const TEXT_FILTER_COLUMNS = ['last_name', 'index', 'email', 'si_number', 'birth_year']
const VT_SELECT_ITEMS = [
  { title: 'I', value: 'I' },
  { title: 'II', value: 'II' },
  { title: 'III', value: 'III' },
]

const columnFilters = reactive({
  last_name: '',
  index: '',
  email: '',
  si_number: '',
  birth_year: '',
})

const vtFilter = ref([])

const boolFilters = reactive({
  organizer: false,
  club_manager: false,
})

const filteredMembers = computed(() => {
  const list = props.members || []
  const selectedVt = vtFilter.value || []

  return list.filter((member) => {
    for (const key of TEXT_FILTER_COLUMNS) {
      const query = String(columnFilters[key] || '').trim().toLowerCase()
      if (!query) continue

      let haystack = ''
      if (key === 'last_name') {
        haystack = `${member.last_name || ''} ${member.first_name || ''}`
      } else {
        haystack = String(member[key] ?? '')
      }

      if (!haystack.toLowerCase().includes(query)) return false
    }

    if (selectedVt.length && !selectedVt.includes(member.current_vt)) return false

    if (boolFilters.organizer && !member.is_organizer) return false
    if (boolFilters.club_manager && !member.is_club_manager) return false

    return true
  })
})

const memberHeaders = computed(() => {
    // Základní hlavičky, které jsou viditelné pro všechny
  let headers = [
    { title: t('club.club_members.headers.name'), key: 'last_name', value: 'last_name', sortable: true, align: 'start' },
    { title: t('club.club_members.headers.index'), key: 'index', value: 'index', sortable: true, align: 'start' },
    { title: t('club.club_members.headers.vt'), key: 'current_vt', value: 'current_vt', width: 88, minWidth: 80, maxWidth: 110, sortable: true, align: 'center' },
  ];
    // Přidáme sloupce pro organizátora a správce oddílu, pokud je uživatel isClubManager
  if (props.isClubManager) {
    headers.push(
        { title: t('club.club_members.headers.email'), key: 'email', value: 'email', sortable: false, align: 'start' },
        { title: t('club.club_members.headers.si_number'), key: 'si_number', value: 'si_number', sortable: false, align: 'start' },

      );
      if (props.isClubManager) {
        headers.push(
          { title: t('club.club_members.headers.birth_year'), key: 'birth_year', value: 'birth_year', sortable: true, align: 'start' },
          { title: t('club.club_members.headers.organizer'), key: 'organizer', value: 'organizer', sortable: false, align: 'start' },
          { title: t('club.club_members.headers.club_manager'), key: 'club_manager', value: 'club_manager', sortable: false, align: 'start' },
          { title: t('club.club_members.headers.actions'), key: 'actions', value: 'actions', sortable: false, width: '120', align: 'start' }
        );
      }
    else
    headers.push(
      { title: t('club.club_members.headers.birth_year'), key: 'birth_year', value: 'birth_year', sortable: true, align: 'start' },
    )

  }
  return headers;
});

// Aktualizace seznamu členů po registraci nového
const showRegistration = ref(false); // Zobrazit dialog pro registraci člena

function onRegistered() {
  showRegistration.value = false;
  // obnov seznam členů
  emit('fetchMembers');
}

const dialogEditAccount = ref(false);
const openEditDialog = (account) => {
  selectedAccount.value = account;
  dialogEditAccount.value = true;
};

const selectedAccount = ref({
  last_name: '',
  first_name: '',
  email: '',
  si_number: null,
  birth_year: null,
  gender: '',
  index: '',
  assist_user: [],
  country: '',
});

const dialogRemoveAccount = ref(false);
const openRemoveDialog = (account) => {
  selectedAccount.value = account;
  dialogRemoveAccount.value = true;
};


const canDeleteAccount = (item) => {
  const currentDate = new Date();
  const joinedDate = new Date(item.date_joined);
  const diffTime = Math.abs(currentDate - joinedDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays <= 14;
};

const dialogDeleteAccount = ref(false);
const openDeleteDialog = (account) => {
  selectedAccount.value = account;
  dialogDeleteAccount.value = true;
};


const rules = {

  isValidEmail: value => (/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) || t('rules.invalid_email'),
  year: value => (value && value >= 1920 && value <= new Date().getFullYear()) || t('rules.born_year_between'),
  siNumber: value => !value || /^\d{4,7}$/.test(value) || t('rules.si_range'),
  index: value => (/^[A-Za-z]{3}\d{4}$/.test(value)) || t('rules.index'),
  firstName: value => (value.trim() !== '') || t('rules.required'),
  last_name: value => (value.trim() !== '') || t('rules.required'),
  gender: value => (['M', 'F'].includes(value)) || t('rules.required')

};

// validace pro disable tlačítka uložit v edit account
const isFormValid = computed(() => {
  return rules.isValidEmail(selectedAccount.value.email) === true &&
    rules.year(selectedAccount.value.birth_year) === true &&
    rules.siNumber(selectedAccount.value.si_number) === true &&
    rules.index(selectedAccount.value.index) === true &&
    rules.firstName(selectedAccount.value.first_name) === true &&
    rules.last_name(selectedAccount.value.last_name) === true &&
    rules.gender(selectedAccount.value.gender) === true;
});

const sexOptions = [{title: t('enums.gender.male'), value: 'M'}, {title: t('enums.gender.female'), value: 'F'}]





const copyEmails = async () => {
   // Filtrování členů, kteří mají email a neobsahují "rob-is.cz"
   const emails = filteredMembers.value
    .filter(member => member.email && !member.email.includes('rob-is.cz'))  // Filtrovat jen členy, kteří mají email a email neobsahuje "rob-is.cz"
    .map(member => member.email)     // Získat emaily
    .join(', ');                     // Spojit emaily do jednoho řetězce odděleného čárkou

  try {
    // Zkopírování emailů do schránky
    await navigator.clipboard.writeText(emails);
    snackbar.success(t('club.club_members.emails_copied'));
  } catch (err) {
    console.error('Chyba při kopírování emailů:', err);
  }
};

const loadingNsaExport = ref(false);

const downloadNsaExport = async (exportType = 'muj_klub') => {
  loadingNsaExport.value = true;
  try {
    const response = await apiClient.get(
      `members/nsa_export/?club_shortcut=${clubShortcut.value}&type=${exportType}`,
      { responseType: 'blob' }
    );
    const disposition = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^"]+)"?/i);
    const fallbackExt = exportType === 'rejstrik' ? 'csv' : 'xlsx';
    const fallbackPrefix = exportType === 'rejstrik' ? 'rejstrik-nsa' : 'podklady-nsa';
    const filename = match?.[1]
      || `${fallbackPrefix}-${clubShortcut.value}-${new Date().toISOString().slice(0, 10)}.${fallbackExt}`;

    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Chyba při stahování NSA exportu:', error);
    snackbar.error(t('club.club_members.nsa_export_failed'));
  } finally {
    loadingNsaExport.value = false;
  }
};

const savingPermissionRoleId = ref(null)

const savePermission = async (member, field, value) => {
  const previous = !!member[field]
  const next = !!value
  if (previous === next) return

  member[field] = next
  savingPermissionRoleId.value = member.role_id

  try {
    const response = await apiClient.post(
      `members/?club_shortcut=${clubShortcut.value}`,
      [{
        role_id: member.role_id,
        is_organizer: !!member.is_organizer,
        is_club_manager: !!member.is_club_manager,
      }]
    )
    if (response.status === 200) {
      snackbar.success(t('club.club_members.permissions_updated'))
      authStore.updateRoles(response.data.user_permissions)
    } else {
      throw new Error('Failed to update member roles')
    }
  } catch (error) {
    member[field] = previous
    console.error('Error updating member roles:', error)
    snackbar.error(t('club.club_members.permissions_update_failed'))
  } finally {
    savingPermissionRoleId.value = null
  }
}



const editAccount = async () => {
  try {
    // Vytvoření jednoduchého objektu z reaktivního selectedAccount
    const accountData = {
      id: selectedAccount.value.id,
      first_name: selectedAccount.value.first_name,
      last_name: selectedAccount.value.last_name,
      email: selectedAccount.value.email,
      si_number: selectedAccount.value.si_number,
      birth_year: selectedAccount.value.birth_year,
      gender: selectedAccount.value.gender,
      index: selectedAccount.value.index,
      assist_user: selectedAccount.value.assist_user,
      country: selectedAccount.value.country,
    };

    const response = await apiClient.put(`/members/?role_id=${selectedAccount.value.role_id}`, accountData);
    if (response.status === 200) {
      if (response.data?.welcome_email_sent) {
        snackbar.successLong(t('club.club_members.account_updated_with_welcome_email'));
      } else {
        snackbar.success(t('club.club_members.account_updated'));
      }
      emit("fetchMembers"); // Aktualizace seznamu členů po úspěšném uložení
      dialogEditAccount.value = false;
      }
    } catch (error) {
    if (error.response && error.response.status === 409) {
      snackbar.error(error.response.data.error)
    } else {
      snackbar.error(t('club.club_members.update_failed') + error.message);
    }
    console.error('Error updating account:', error);
  }
};



const removeAccount = async () => {
  try {
    const response = await apiClient.post(`members/?remove_index=${selectedAccount.value.index}`);
    if (response.status === 200) {
      snackbar.success(t('club.club_members.account_removed'));
      emit("fetchMembers"); // Obnovit seznam členů po úspěšném vyřazení
    } else {
      throw new Error('Failed to delete account');
    }
  } catch (error) {
    console.error('Error deleting account:', error);
  } finally {
    dialogRemoveAccount.value = false;
  }
};



const deleteAccount = async () => {
  try {
    const response = await apiClient.delete(`members/?account_id=${selectedAccount.value.id}`);
    if (response.status === 200) {
      snackbar.success(t('club.club_members.account_deleted'));
      emit("fetchMembers"); // Obnovit seznam členů po úspěšném smazání
    }
  } catch (error) {
    console.error('Error deleting account:', error);

    if (error.response) {
      if (error.response.status === 409) {
        snackbar.error(error.response.data.error || t('club.club_members.account_delete_conflict'));
      } else {
        snackbar.error(t('club.club_members.account_delete_failed'));
      }
    } else {
      snackbar.error(t('club.club_members.account_delete_failed'));
    }

  } finally {
    dialogDeleteAccount.value = false;

  }
};


</script>

<style scoped>
.member-header-cell {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  width: 100%;
  min-width: 0;
  padding: 8px 0;
  box-sizing: border-box;
}

.member-header-cell--center .v-data-table-header__content {
  justify-content: center;
}

.member-bool-filter {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.member-bool-filter :deep(.v-selection-control) {
  min-height: 28px;
}

.member-header-filter {
  width: 100% !important;
  max-width: 100%;
  font-weight: 400;
  text-transform: none;
}

.member-header-filter :deep(.v-input),
.member-header-filter :deep(.v-input__control),
.member-header-filter :deep(.v-field) {
  width: 100%;
}

.member-header-filter :deep(.v-field) {
  font-size: 0.8125rem;
}

.member-header-filter :deep(.v-field__input) {
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

:deep(th.v-data-table__th) {
  vertical-align: top;
}

:deep(th.v-data-table__th .member-header-cell) {
  align-self: stretch;
  flex: 1 1 auto;
  width: 100%;
}
</style>
